import { formatHours } from "@/lib/formatHours";

type TechnicianHoursSummaryProps = {
  totalApprovedHours: number;
  totalTechnicians: number;
  averageApprovedHours: number;
};

export function TechnicianHoursSummary({
  totalApprovedHours,
  totalTechnicians,
  averageApprovedHours,
}: TechnicianHoursSummaryProps) {
  const stats = [
    { label: "Approved hours", value: formatHours(totalApprovedHours) },
    { label: "Team members", value: String(totalTechnicians) },
    { label: "Avg / member", value: formatHours(averageApprovedHours) },
  ];

  return (
    <div className="flex rounded-[10px] border border-slate-200 bg-white shadow-[0_1px_2px_#0000000A]">
      {stats.map((stat, index) => (
        <div
          key={stat.label}
          className={`flex flex-1 flex-col p-3 ${
            index > 0 ? "border-l border-slate-200" : ""
          }`}
        >
          <span className="text-2xl font-semibold tabular-nums tracking-[-0.02em] text-slate-800">
            {stat.value}
          </span>
          <span className="mt-1 text-xs font-medium text-slate-500">
            {stat.label}
          </span>
        </div>
      ))}
    </div>
  );
}
